import * as z from "zod";

import { referrerSummarySchema, referrerTypeSchema } from "./shared";

export const createReferrer = {
  name: "createReferrer" as const,
  input: z.object({
    email: z.string().email(),
    name: z.string().min(1).max(200),
    /** If omitted, the server auto-generates from `name`. */
    referralCode: z.string().min(3).max(20).optional(),
    referrerType: referrerTypeSchema,
    /**
     * When true, the server signs a magic link and attempts delivery as
     * part of the create flow. Failure does NOT roll back referrer creation —
     * the response surfaces the failure tag so the admin UI can offer a
     * "resend" affordance.
     */
    sendMagicLinkImmediately: z.boolean().default(true),
  }),
  output: z.object({
    referrer: referrerSummarySchema,
    magicLinkSent: z.boolean(),
    magicLinkError: z.string().optional(),
  }),
};
